let Debug = require('./Debug');
let { countGlobalChildren } = require('./index');

class ChildCounter {
  constructor (game) {
    let childCount = 0;
    let prevChildCount = 0;
    let childCountDisplay;
    childCountDisplay = new Debug({
      left: 0,
      bottom: '24px'
    });
    childCountDisplay.setText(`Global child count: ${childCount}`);
    childCounterLoop();
    function childCounterLoop () {
      childCount = countGlobalChildren(game.scene.scenes);
      if (childCount !== prevChildCount) {
        childCountDisplay.setText(`Global child count: ${childCount}`);
        prevChildCount = childCount;
      }
      requestAnimationFrame(childCounterLoop);
    }
  }
}

module.exports = ChildCounter;
